import FirstName     from "./FirstName";
import FirstNameKana from "./FirstNameKana";
import LastName      from "./LastName";
import LastNameKana  from "./LastNameKana";

class Name {
  constructor(
    private readonly _lastName: LastName = new LastName(),
    private readonly _firstName: FirstName = new FirstName(),
    private readonly _lastNameKana: LastNameKana = new LastNameKana(),
    private readonly _firstNameKana: FirstNameKana = new FirstNameKana()
  ) {
  }

  get lastName() {
    return this._lastName;
  }

  get firstName() {
    return this._firstName;
  }

  get lastNameKana() {
    return this._lastNameKana;
  }

  get firstNameKana() {
    return this._firstNameKana;
  }

  public asFull(): string {
    return `${this._lastName.value}  ${this._firstName.value}`;
  }
}

export default Name;
